/** @format */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'pdp-carousel-skeleton-loader',
	templateUrl: './carousel-skeleton-loader.component.html',
	styleUrl: './carousel-skeleton-loader.component.scss',
	imports: [CommonModule]
})
export class CarouselSkeletonLoaderComponent {}
